var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.788 1.20997C9.236 0.132972 10.764 0.132972 11.212 1.20997L13.294 6.21697L18.698 6.64997C19.862 6.74297 20.334 8.19497 19.447 8.95497L15.33 12.482L16.587 17.755C16.858 18.891 15.623 19.788 14.627 19.18L10 16.354L5.373 19.18C4.377 19.788 3.142 18.89 3.413 17.755L4.67 12.482L0.553003 8.95497C-0.333998 8.19497 0.138003 6.74297 1.302 6.64997L6.706 6.21697L8.788 1.20997Z","fill":"#FDE047"}));
}

Star.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Star;

Star.default = Star;
